
import infinityLogo from '../Media/Clearloop_infinityLogo_01.svg'
import clearloopLogo from '../Media/Clearloop_Brandmark_white_01.svg'

const Success = (props) => {

    const userTons = () => {
        return(
            <div className="result-box">
                <div className="row space-between">
                    <div className="col">
                        <p className="f-14 f-gray">Your choice of:</p>
                        <div className="input-rect">
                            <p className="ml-1 f-20 f-bold">
                                {props.tons}
                            </p>
                            <p id="right-sign">t</p>
                        </div>
                        <p className="f-12 f-yellow">METRIC TONS</p>
                    </div>
                    <img id="infinity-logo" src={infinityLogo} alt="clearloop infinity symbol"/>
                    <div className="col">
                        <p className="f-14 f-gray">Is equal to:</p>
                        <div className="input-rect">
                            <p id="dollar-sign">$</p>
                            <p className="mr-1 f-20 f-bold f-c">
                                {props.money}
                            </p>
                        </div>
                        <p className="f-12 f-yellow">MONEY SPENT</p>
                    </div>
                    <div className="col">
                        <p className="f-14 f-gray">Is equal to:</p>
                        <div className="input-rect f-c">
                            <p className="ml-1 f-20 f-bold">
                                {props.watts}
                            </p>
                            <p id="right-sign">w</p>
                        </div>
                        <p className="f-12 f-yellow">SOLAR WATTS</p>
                    </div>
                </div>
            </div>
        )
    }

    const userDollars = () => {
        return(
            <div className="result-box">
                <div className="row space-between">
                    <div className="col">
                        <p className="f-14 f-gray">Your choice of:</p>
                        
                        <div className="input-rect">
                            <p id="dollar-sign">$</p>
                            <p className="mr-1 f-20 f-bold f-c">
                                {props.money}
                            </p>
                        </div>
                        <p className="f-12 f-yellow">MONEY SPENT</p>
                    </div>
                    
                    <img id="infinity-logo" src={infinityLogo} alt="clearloop infinity symbol"/>
                    
                    <div className="col">
                        <p className="f-14 f-gray">Is equal to:</p>
                        <div className="input-rect">
                            <p className="ml-1 f-20 f-bold">
                                {props.tons}
                            </p>
                            <p id="right-sign">t</p>
                        </div>
                        <p className="f-12 f-yellow">METRIC TONS</p>
                    </div>
                    <div className="col">
                        <p className="f-14 f-gray">Is equal to:</p>
                        <div className="input-rect f-c">
                            <p className="ml-1 f-20 f-bold">
                                {props.watts}
                            </p>
                            <p id="right-sign">w</p>
                        </div>
                        <p className="f-12 f-yellow">SOLAR WWATTS</p>
                    </div>
                </div>
            </div>
        )
    }

    const userWatts = () => {
        return(
            <div className="result-box">
                <div className="row space-between">
                    <div className="col">
                        <p className="f-14 f-gray">Your choice of:</p>
                        
                        <div className="input-rect f-c">
                            <p className="ml-1 f-20 f-bold">
                                {props.watts}
                            </p>
                            <p id="right-sign">w</p>
                        </div>
                        <p className="f-12 f-yellow">SOLAR WATTS</p>
                    </div>
                    <img id="infinity-logo" src={infinityLogo} alt="clearloop infinity symbol"/>
                    <div className="col">
                        <p className="f-14 f-gray">Is equal to:</p>
                        <div className="input-rect">
                            <p id="dollar-sign">$</p>
                            <p className="mr-1 f-20 f-bold f-c">
                                {props.money}
                            </p>
                        </div>
                        <p className="f-12 f-yellow">MONEY SPENT</p>
                    </div>
                    <div className="col">
                        <p className="f-14 f-gray">Is equal to:</p>
                        <div className="input-rect">
                            <p className="ml-1 f-20 f-bold">
                                {props.tons}
                            </p>
                            <p id="right-sign">t</p>
                        </div>
                        <p className="f-12 f-yellow">METRIC TONS</p>
                    </div>
                </div>
            </div>
        )
    }

    const selectLayout = () => {
        switch(props.choice){
            case 'tons':
                return(userTons())
            case 'dollars':
                return(userDollars())
            case 'watts':
                return(userWatts())
            default:
                return(
                    <div>
                        <p>looks l ike there was a problem processing your request. Please try again later.</p>
                    </div>
                )
        }
    }

    return(
        <div>
            <p className="f-c mb-2 f-20">Congratulations!</p>
            {selectLayout()}
            <h1 className="f-c title-text mt-2">Thank you for your interest in supporting our Mississippi project.</h1>
            <p className="f-c">A Clearloop team member will be in touch to take the next steps together.</p>
            <div className='row'>
                <img id="brandmark" src={clearloopLogo} alt="clearloop logo" />
            </div>
        </div>
    )
}

export default Success;